const leg = require('./leg');

function segment(segmentData) {
    const that = {};
    const legs = Odigeo._.map(segmentData.sections, (flightLeg) => {
        return leg(flightLeg);
    });

    that.getDuration = function() {
        return segmentData.duration;
    };

    that.getLeg = function(index) {
        return legs[index];
    };

    that.getLegsCount = function() {
        return legs.length;
    };

    that.getDepartureLeg = function() {
        return legs[0];
    };

    that.getArrivalLeg = function() {
        return Odigeo._.last(legs);
    };

    return that;
}

module.exports = segment;
